/* Comments section edit form */

window.showEditForm = function (id, editButton) {
    var originalComment = document.getElementById('original-comment-' + id);
    var editComment = document.getElementById('edit-comment-' + id);
    var deleteButton = document.getElementById('delete-button-' + id);
    var replyButton = document.getElementById('reply-button-' + id); 

    if (editComment.style.display === "none") {
        editComment.style.display = "block";
        originalComment.style.display = "none";
        editButton.style.display = "none";
        deleteButton.style.display = "none";
        replyButton.style.display = "none"; 
    } else {
        editComment.style.display = "none";
        originalComment.style.display = "block";
        editButton.style.display = "inline-block";
        deleteButton.style.display = "inline-block";
        replyButton.style.display = "block";
    }
}


window.showReplyForm = function (commentId) {
    var replyForm = document.getElementById('reply-comment-' + commentId);
    if (replyForm.style.display === 'none') {
        replyForm.style.display = '';
    } else {
        replyForm.style.display = 'none';
    }
}
